import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import { renderLeafBackgroundColor } from './renderLeafBackgroundColor';
import { BackgroundColorMarkPluginOptions } from './types';

export const BackgroundColorPlugin = (options?: BackgroundColorMarkPluginOptions): SlatePlugin => ({
  renderLeaf: renderLeafBackgroundColor(options),
});
